import { client } from "./client";

export const fetchWorkLogs = async (program = "internship") => {
    const response = await client.get("/api/work-logs/", { params: { program } });
    return response.data;
};

export const createWorkLog = async ({ program = "internship", ...payload }) => {
    const response = await client.post("/api/work-logs/", { ...payload, program });
    return response.data;
};

export const updateWorkLog = async ({ id, ...payload }) => {
    const response = await client.put(`/api/work-logs/${id}/`, payload);
    return response.data;
};

export const deleteWorkLog = async (id) => {
    await client.delete(`/api/work-logs/${id}/`);
};
